import BaseGallery from "./BaseGallery";
import Helper from "../Helper";
import Splide from '@splidejs/splide';

/**
 * This class represents Splide splider gallery on the page.
 * Fullscreen Gallery means, that it will open gallery on whole window and on clicking the image, the Splide Slider will appear.
 */
export default class FullscreenGallery extends BaseGallery {

  /**
   * Initialize gallery.
   *
   * @param {Element} galleryName
   */
    constructor(galleryName)
    {
        super(galleryName, 'fullscreen-');
        this.galleryImages = this.gallery.find('[data-gallery]');

        this.step = 'closed';
    }

    /**
    * This function will init the gallery toggles. Those will open fullscreen gallery.
    */
    initGallery()
    {
        this.galleryToggles.find('a').click((event) => {
            let showOnTablet = $(event.target).data('donttoggleontablet');

            if (showOnTablet !== 1 || !Helper.isTabletOrLower()) {
                event.preventDefault();
                this.openGallery();
            }

            window.imageSizes.updateSizes();
        })
    }

    /**
    * This function will init the gallery, including the logic for its slider toggling and slider initialisation.
    */
    initGallerySlider()
    {
        if (this.slider === undefined) {
            this.slider = new Splide('#'+this.gallerySlider.attr('id'), this.sliderOptions).mount();

            if (window.innerWidth <= 1052) {
                this.slider.on('lazyload:loaded', (img) => {
                    if (img.width > img.height) {
                        $(img).height(window.innerWidth * 0.6667);
                    } else {
                        $(img).width(window.innerWidth);
                        $(img).height(window.innerHeight * 0.75);
                    }
                });
            }

            this.galleryImages.find('a').click((event) => {
                event.preventDefault();
                this.openSlider($(event.currentTarget).data('count'));
            });

            this.gallery.find('[data-gallery-step-back]').click(() => {
                  this.stepBack();
            });

            this.gallery.find('[data-close]').click(() => {
                  this.closeGallery();
            });

            this.initDependencies();
        }
    }

    /**
    * Initialise possible gallery dependencies.
    */
    initDependencies()
    {
        this.gallery.find('[data-readmore]:visible').readmore();
    }

    /**
    * This function will open the fullscreen gallery and initialise the slider if its not already.
    */
    openGallery()
    {
        if (this.galleryImages.length > 0) {
            this.updateStep('opened');
            $('html').css('overflow-y', 'hidden');
        } else {
            this.updateStep('slider');
        }
        this.initGallerySlider();
    }

    /**
    * This function will close the fullscreen gallery.
    */
    closeGallery()
    {
        this.updateStep('closed');

        $('body').css({
            'overflow-y': 'scroll'
        });

        $('html').css({
            'overflow-y': 'unset'
        });
    }

    /**
    * This function will open gallery slider on given slide (taken from href)
    *
    * @param {String} count
    */
    openSlider(count)
    {
        this.updateStep('slider');
        this.slider.go(count, false);
    }

    /**
    * This function handles stepping back in gallery.
    */
    stepBack()
    {
        switch (this.step) {
            case 'slider': {
                if (this.galleryImages.length <= 0) {
                    this.closeGallery();
                    break;
                }

                this.updateStep('opened');
                break;
            }
            case 'opened': {
                this.closeGallery();
                break;
            }
        }
    }

    /**
    * This function will update gallery step. This will show/hide correct gallery contents and updates gallery CSS class.
    *
    * @param {String} newStep
    */
    updateStep(newStep)
    {
        this.gallery.removeClass(this.step);
        this.gallery.find('[data-gallery-step="' +  this.step + '"]').addClass('hidden-mvio');
        this.step = newStep;
        this.gallery.addClass(this.step);
        this.gallery.find('[data-gallery-step="' +  this.step + '"]').removeClass('hidden-mvio');

        if (this.step === 'opened' || this.step === 'slider') {
            $('body').css('overflow', 'hidden');
        }
    }
}
